// extracted by mini-css-extract-plugin
export default {"Litags":"AdminNavbar_Litags__5e8fC","NaTags":"AdminNavbar_NaTags__x4aaB","STags":"AdminNavbar_STags__61coR","Dnav":"AdminNavbar_Dnav__fgIX3"};